"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONFIG_API_BASE_URL = exports.ADDRESS_API_BASE_URL = void 0;
const ADDRESS_API_BASE_URL = exports.ADDRESS_API_BASE_URL = '/api/address/v1';
const CONFIG_API_BASE_URL = exports.CONFIG_API_BASE_URL = '/api/postsales/config/v1';